import { Col, Container, Row } from 'react-bootstrap'
import ArticleItem from '../../components/article/ArticleItem'
import Navbar from '../../components/navbar/MyNavbar'
import './Home.css'
import { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import Footer from '../../components/footer/Footer'
import Hero from '../../components/hero/Hero'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import SwiperButtons from '../../components/swiperButtons/SwiperButtons'
import CourseItem from '../../components/course/CourseItem'


function Home() {
    // and we use useState hook for save the api information 

    const [articles, setArticles] = useState([])
    const [courses, setCourses] = useState([])


    // we use useEffect hook and axios package for get api information 
    useEffect(() => {
        // this url for articles :
        // here on this url below we receive newest articles from data base
        axios.get('http://localhost/react/api/articles/?page=1&limit=6')
            .then(response => setArticles(response.data.data))


        // this url for courses :
        axios.get('http://localhost/react/api/courses/?page=1&limit=8')
            .then(response => setCourses(response.data.data))
    }, [])

    // here we use useRef for save our buttons values 

    const swiperRef = useRef(null);
    const courseSwiperRef = useRef(null)


    return (
        <>
            <Navbar />
            <Hero />
            <Container>
                {/* course section : */}
                 <Row className='py-3'>
                    {/* swiper btn for moving our articles and text of artiles */}
                    <div className='swiperTopSection'>
                        <h2 className="sectionTitle vidalokaFont">The latest Courses</h2>
                        <SwiperButtons swiperRef={courseSwiperRef} />

                    </div>

                    <Swiper
                        onSwiper={(swiper) => { courseSwiperRef.current = swiper; }}
                        pagination={{
                            clickable: true,
                        }}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: false
                        }}
                        modules={[Autoplay, Pagination]}
                        className="mySwiper pb-5 customSwiperStyle"
                        spaceBetween={30}
                        // making our sildes responsive
                        breakpoints={{
                            1200: {
                                slidesPerView: 4
                            },
                            992: {
                                slidesPerView: 3
                            },
                            768: {
                                slidesPerView: 2
                            },
                            576: {
                                slidesPerView: 1
                            }
                        }}
                    >
                        {courses.map(course => (
                            <SwiperSlide><CourseItem {...course} /></SwiperSlide>
                        ))}

                    </Swiper>
                </Row>

               
                {/* articles section : */}
                <Row className='py-3'>
                    {/* swiper btn for moving our articles and text of artiles */}
                    <div className='swiperTopSection'>
                        <h2 className="sectionTitle vidalokaFont">The latest Articles</h2>
                        <SwiperButtons swiperRef={swiperRef} />

                    </div>

                    <Swiper
                        onSwiper={(swiper) => { swiperRef.current = swiper; }}
                        pagination={{
                            clickable: true,
                        }}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false
                        }}
                        modules={[Autoplay, Pagination]}
                        className="mySwiper pb-5 customSwiperStyle"
                        spaceBetween={30}
                        // making our sildes responsive
                        breakpoints={{
                            1200: {
                                slidesPerView: 4
                            },
                            992: {
                                slidesPerView: 3
                            },
                            768: {
                                slidesPerView: 2
                            },
                            576: {
                                slidesPerView: 1
                            }
                        }}
                    >
                        {articles.map(article => (
                            <SwiperSlide><ArticleItem {...article} /></SwiperSlide>
                        ))}

                    </Swiper>
                </Row>
            </Container>
            <Footer />
        </>

    )
}

export default Home